import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useArtistStore = defineStore('artist', () => {
  const id = ref('d2870ec8-16ee-4a3e-ae85-477632ea89d3');
  const shortName = ref('sparklejumpropequeen');
  const name = ref('Lana');
  const returnUrl = ref<string>(import.meta.env.VITE_HOME_URL);
  const minAge = ref(13);

  return {
    id,
    shortName,
    name,
    returnUrl,
    minAge,
  };
});
